import React from 'react'

const UseUserProfileMenu = () => {

  return {

  }
}

export default UseUserProfileMenu;